import { render, staticRenderFns } from "./SearchResults.vue?vue&type=template&id=54880965&scoped=true&"
import script from "./SearchResults.vue?vue&type=script&lang=ts&"
export * from "./SearchResults.vue?vue&type=script&lang=ts&"
import style0 from "./SearchResults.vue?vue&type=style&index=0&id=54880965&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54880965",
  null
  
)

export default component.exports